import type {ChoiceQuestionModel} from '../../Question/ChoiceQuestion/ChoiceQuestion.model';
import type {AnswerModelProps} from '../Answer.model';

import {AnswerModel} from '../Answer.model';

export class CheckboxesAnswerModel extends AnswerModel<
  string[],
  ChoiceQuestionModel
> {
  constructor(props: AnswerModelProps<string[], ChoiceQuestionModel>) {
    super(props);
  }

  get isValid(): boolean {
    return Boolean(this.value?.length);
  }

  getScore(question: ChoiceQuestionModel): number {
    if (!this.value) {
      return 0;
    }

    return this.value
      .map(
        optionId =>
          question.options.find(option => option.id === optionId)?.score ?? 0,
      )
      .reduce((acc, score) => acc + score, 0);
  }

  toString(): string {
    if (!this.value) {
      return '';
    }

    return this.value
      .map(
        optionId =>
          this.question.options.find(option => option.id === optionId)?.title ??
          '',
      )
      .join(', ');
  }
}
